/**
 * Custom Footer section
 * ---------------------------------------------------------------------------
 * Extracted from sections/custom-footer.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="custom-footer"]';

  function initSection(footerEl) {
    if (!footerEl || footerEl.dataset.customfooterInit === 'true') return;
    footerEl.dataset.customfooterInit = 'true';

    var sectionId = footerEl.dataset.sectionId;
    // 1. Newsletter Modal Trigger
    const modal = document.getElementById('FooterNewsletterModal-' + sectionId);
    const trigger = footerEl.querySelector('#FooterNewsletterBtn-' + sectionId);
    if (modal && trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        modal.classList.add('is-open');
      });

      const closeBtn = modal.querySelector('.custom-footer__newsletter-close');
      const backdrop = modal.querySelector('.custom-footer__newsletter-backdrop');

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          modal.classList.remove('is-open');
        });
      }
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          modal.classList.remove('is-open');
        });
      }
    }

    // 3. Update select box labels on change
    const selects = footerEl.querySelectorAll('.custom-footer__native-select');
    selects.forEach(select => {
      select.addEventListener('change', function () {
        const textEl = this.parentElement.querySelector('.custom-footer__select-text');
        const selectedOption = this.options[this.selectedIndex];
        if (textEl && selectedOption) {
          textEl.textContent = selectedOption.text;
        }
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
